<script setup lang="ts">
import { RowInfo } from '@shared/ui/other'

import { useMainInfoPaidLabel } from '../../model/use-main-info-paid-label.hook'

defineOptions({
  name: 'MainInfoPaidLabel',
})

const { refValue } = useMainInfoPaidLabel()
</script>

<template>
  <RowInfo
    title="Paid label"
    :value="refValue"
  />
</template>
